import React, { useEffect, useState, useRef } from "react";
import { Mentions, Avatar, Button, Card, Input, List, Space, Typography, Dropdown, Upload, Tag, message, Tooltip, Image, Affix, Spin } from "antd";
import { LikeOutlined, LikeFilled, MessageOutlined, SendOutlined, SmileOutlined, PaperClipOutlined, DeleteOutlined, MoreOutlined, UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { convertDateToUserTimezone } from "../Components/Utility"; // Adjust the import path as needed
import { DateFormat, DateTimeFormat } from "../Components/Constant"; // Adjust the import path as needed
import Cookies from "js-cookie";
import eventBus from "../Components/eventBus";
import MessageInput from "../Chat/MessageInput";
import Editor from "../ChatTextEditor/Editor";

dayjs.extend(relativeTime);

const { Text,Title } = Typography;
const { TextArea } = Input;
const { Option } = Mentions;



  function HtmlContent({ content }) {
    return (
      <div>
        <style>
          {`
            div.HtmlContentWrapper p {
              margin: 0;
              padding: 0;
            }

            div.HtmlContentWrapper img {
              max-width: 100%;
              height: auto;
              max-height: 300px;
              display: block;
              margin: 10px 0;
            }
          `}
        </style>
        <div className="HtmlContentWrapper" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }


const Feed = ({ objectName, recordId, metadata }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [replyText, setReplyText] = useState({});
  const [replyVisible, setReplyVisible] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [activeReplyId, setActiveReplyId] = useState(null);
  const [users, setUsers] = useState(null);
  const [loading, setLoading] = useState(false);
  const textareaRef = useRef(null);
  const highlightRef = useRef(null);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingContent, setEditingContent] = useState("");
  const currentuserId = Cookies.get("userId") || null;
  const [editText, setEditText] = useState("");
  const [editingReplyId, setEditingReplyId] = useState(null);
  const [editReplyText, setEditReplyText] = useState("");
  const [replyAttachments, setReplyAttachments] = useState({});

  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  

  useEffect(() => {
    fetchComments();
    fetchUsers();
  }, [objectName, recordId]);

  const fetchComments = async () => {
    try {
      setLoading(true);
      const body = {
        object_name: objectName,
        record_id: recordId,
      };
      const apiService = new ApiService(
        `${BASE_URL}/comments?object_name=${objectName}&record_id=${recordId}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const data = await apiService.makeCall();
      setComments(data || []);
    } catch (err) {
      message.error("Failed to load comments");
    }
    finally {
      setLoading(false);
    }
  };


  const fetchUsers = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}//fetch_records/User`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const data = await apiService.makeCall();
      setUsers(data.records);

    } catch (err) {

    }

  };

  // Like a comment
  const handleLike = (id) => {
    setComments((prev) =>
      prev.map((comment) =>
        comment.id === id
          ? {
            ...comment,
            likes: comment.liked
              ? comment.likes - 1
              : comment.likes + 1,
            liked: !comment.liked,
          }
          : comment
      )
    );
  };

  // Add new comment
  const handleAddComment = async ({html,files,id}) => {

    console.log('handleAddComment called with:', id);

    // if (!newComment?.trim() && attachments.length === 0) return;

    try {
      setLoading(true);
      if (id) {
        // update existing comment
        const payload = {
          comment: {
            content: html,
            attachments: files.map((file) => ({
              type: (file.filename?.split('.').pop()?.toLowerCase && (() => {
                const ext = file.filename.split('.').pop().toLowerCase();
                const imageExtensions = ["png", "jpg", "jpeg", "gif", "bmp", "webp"];
                return imageExtensions.includes(ext) ? "image" : "file";
              })()) || 'file',
              filename: file.filename,
              content: file.base64code || file.base_64_data || null,
              base_64_data: file.base64code || file.base_64_data || null,
              url: file.url || null,
            })),
          },
        };

        console.log('Updating comment with payload:', payload, id);

        const apiService = new ApiService(
          `${BASE_URL}/comments/${id}`,
          { "Content-Type": "application/json" },
          "PUT",
          payload
        );
        await apiService.makeCall();
        message.success("Comment updated");
        setEditingCommentId(null);
      } else {
        // create new comment
        const payload = {
          comment: {
            content: html,
            privacy: "public",
            tags: [],
            attachments: files.map((file) => {
              const ext = file.filename?.split('.').pop().toLowerCase();
              const imageExtensions = ["png", "jpg", "jpeg", "gif", "bmp", "webp"];
              const type = imageExtensions.includes(ext) ? "image" : "file";
              return {
                type,
                filename: file.filename,
                content: file.base64code || file.base_64_data || null,
                base_64_data: file.base64code || file.base_64_data || null,
              };
            }),
          },
          object_name: objectName,
          record_id: recordId,
        };

        const apiService = new ApiService(
          `${BASE_URL}/comments`,
          { "Content-Type": "application/json" },
          "POST",
          payload
        );
        await apiService.makeCall();
        message.success("Comment added");
      }

      // reset editor
      setNewComment("");
      setAttachments([]);
      fetchComments();
    } catch (err) {
      console.error(err);
      message.error(editingCommentId ? "Failed to update comment" : "Failed to post comment");
    } finally {
      setLoading(false);
    }
  };

  const emojiMenu = (id) => ({
    items: [
      { key: "1", label: <span onClick={() => handleReact(id, "👍")}>👍</span> },
      { key: "2", label: <span onClick={() => handleReact(id, "❤️")}>❤️</span> },
      { key: "3", label: <span onClick={() => handleReact(id, "😂")}>😂</span> },
      { key: "4", label: <span onClick={() => handleReact(id, "🎉")}>🎉</span> },
    ],
  });

  const handleReact = async (id, emoji) => {
    try {
      setLoading(true);
      const response = new ApiService(
        `${BASE_URL}/comments/${id}/react`,
        { "Content-Type": "application/json" },
        "POST",
        { emoji: emoji }
      );
      await response.makeCall();
      fetchComments(); // Refresh comments after reaction
    } catch (error) {
    }
  };



  const handleReply = async (data) => {

    const content= data?.html || "";
    const parentId=data?.parentId;
    const files=data?.files || [];
    const replyId=data?.replyId;


    const payload = {
      parent_id: parentId,
      comment: {
        content,
        privacy: "public",
        tags: [], // you can add tags if needed
        attachments: Array.isArray(files)
          ? files.map((file) => {
            // get file extension in lowercase
            const ext = file?.filename?.split('.')?.pop()?.toLowerCase();

            // define image extensions
            const imageExtensions = ["png", "jpg", "jpeg", "gif", "bmp", "webp"];

            // check if extension is in imageExtensions array
            const type = imageExtensions.includes(ext) ? "image" : "file";

            return {
              type,
              url: file?.url || file.response?.url,
              thumbnail: file?.thumbUrl || file.response?.thumbnail,
              filename: file?.filename,
              content: file?.base64code,
            };
          })
          : [], // if not array, send empty
      },
    };


    if(!replyId){

    try {
      setLoading(true);
      const apiService = new ApiService(
        `${BASE_URL}/comments/${parentId}/reply`,
        { "Content-Type": "application/json" },
        "POST",
        payload
      );
      await apiService.makeCall();
      message.success("Reply posted");
      setReplyText((prev) => ({ ...prev, [parentId]: "" }));
      setReplyVisible((prev) => ({ ...prev, [parentId]: false }));
      setActiveReplyId(null);
      setReplyAttachments(null);
      fetchComments(); // refresh to get new reply from backend
    } catch (err) {
      console.error("Failed to post reply:", err);
      message.error("Failed to post reply");
    }
    }
    else{
      try {
      setLoading(true);
      const apiService = new ApiService(
        `${BASE_URL}/comments/${replyId}`,
        { "Content-Type": "application/json" },
        "PUT",
        {
          comment: { content: content }
        }
      );
      await apiService.makeCall();
      fetchComments();
      setEditingReplyId(null);
    } catch (err) {
      console.error(err);
    }

    }

  };

  const handleEditComment = async (commentId) => {
    try {
      setLoading(true);
      const apiService = new ApiService(
        `${BASE_URL}/comments/${commentId}`,
        { "Content-Type": "application/json" },
        "PUT",
        {
          comment:
            { content: editText }
        }
      );
      await apiService.makeCall();
      fetchComments(); // Refresh comments after edit
      message.success("Comment updated");
      setEditingCommentId(null);
    } catch (error) {
      console.error("Error updating comment:", error);
    }

  };

  const handleDeleteComment = async (commentId) => {
    // try {
    //   const apiService = new ApiService(
    //     `${BASE_URL}/comments/${commentId}`,
    //     { "Content-Type": "application/json" },
    //     "DELETE"
    //   );
    //   await apiService.makeCall();
    //   message.success("Comment deleted");
    //   setComments((prev) => prev.filter((c) => c.id !== commentId));
    // } catch (error) {
    //   console.error("Error deleting comment:", error);
    // }
  };

  const handleEditReply = async (commentId, replyId) => {
    try {
      setLoading(true);
      const apiService = new ApiService(
        `${BASE_URL}/comments/${replyId}`,
        { "Content-Type": "application/json" },
        "PUT",
        {
          comment: { content: editReplyText }
        }
      );
      await apiService.makeCall();
      fetchComments();
      setEditingReplyId(null);
    } catch (err) {
      console.error(err);
    }

  };

  const handleDeleteReply = async (commentId, replyId) => {
    // try {
    //  const apiService = new ApiService( 

    //     `${BASE_URL}/comments/${commentId}/replies/${replyId}`,
    //     { "Content-Type": "application/json" },
    //     "DELETE"
    //   );
    //   await apiService.makeCall();  
    //   fetchComments(); // Refresh comments after delete
    // } catch (err) {
    //   console.error(err);
    // }
  };

  // Function to preview PDF file
  const previewPDF = (base64Data) => {
    const binary = atob(base64Data); // Decode base64 data
    const byteArray = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      byteArray[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };


  // Function to preview Image (JPG, PNG, etc.)
  const previewImage = (base64Data, ext) => {
    let mimeType;
    switch (ext) {
      case "jpg":
      case "jpeg":
        mimeType = "image/jpeg";
        break;
      case "png":
        mimeType = "image/png";
        break;
      case "gif":
        mimeType = "image/gif";
        break;
      case "bmp":
        mimeType = "image/bmp";
        break;
      case "webp":
        mimeType = "image/webp";
        break;
      default:
        mimeType = "application/octet-stream"; // fallback
    }
  
    const src = base64Data.startsWith("data:")
      ? base64Data
      : `data:${mimeType};base64,${base64Data}`;
  
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head><title>Image Preview</title></head>
          <body style="margin:0;display:flex;justify-content:center;align-items:center;height:100vh;background:#f0f0f0;">
            <img src="${src}" style="max-width:100%;max-height:100%;" />
          </body>
        </html>
      `);
    }
  };
    

  const handleFilePreview = (filename, base64Data) => {
    try {
      // Extract file type from the file name
      const fileName = filename;
      const fileExtension = fileName?.split('.').pop()?.toLowerCase();

      console.log('fileExtension:', fileExtension);
      if (!base64Data) {
        message.error('No file data available to preview');
        return;
      }

      // Handle preview based on file extension
      switch (fileExtension) {
        case 'pdf':
          previewPDF(base64Data);
          break;
        case 'docx':
        case 'doc':
          message.info('Preview not available for Word files. Please download to view.');
          break;
        case 'csv':
          message.info('Preview not available for CSV files. Please download to view.');
          break;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'bmp':
        case 'webp':
          previewImage(base64Data, fileExtension);
          break;
        default:
          message.error('Unsupported file type for preview');
          break;
      }
    } catch (error) {
      // Handle any errors during the process
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to preview file due to an unknown error';
      message.error(errorMessage); // Show error message to the user
    }
  };


const openEditorForEdit = (comment) => {
  console.log('openEditorForEdit comment:', comment);
    // set the comment id we are editing
    setEditingCommentId(comment.id);

    // set editor HTML content (preserve mentions / formatting)
    setNewComment(comment.content || "");

    // map existing attachments into MessageInput shape
    const mapped = Array.isArray(comment.attachments)
      ? comment.attachments.map((att) => ({
          filename: att.filename,
          base64code: att.base_64_data || att.base64code || null,
          base_64_data: att.base_64_data || att.base64code || null,
          url: att.url || null,
        }))
      : [];

    setAttachments(mapped);

    // optional: scroll editor into view so user sees it
    // MessageInput uses an element with id="editor", attempt to focus it
    setTimeout(() => {
      const el = document.getElementById("editor");
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  };


  const renderComment = (comment) => {
    const isOwner = comment.user?.id === currentuserId;
    const isEditing = editingCommentId === comment.id;
    const isReplying = activeReplyId === comment.id;

    return (
      <Card
        key={comment.id}
        style={{
          marginBottom: 16,
          borderRadius: 7,
          backgroundColor: theme === "dark" ? "#141414" : "#ffffff", // ✅
          color: theme === "dark" ? "#ffffff" : "#1A1A1A",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        }}
        bodyStyle={{ padding: 16 }}
      >
        <Space align="start" style={{ width: "100%" }}>

          {comment.user?.image ? (
                    <img
                      src={`data:image/png;base64,${comment.user?.image}`}
                      alt="profile"
                      style={{
                        width: 24, // Avatar small size
                        height: 24,
                        borderRadius: "50%", // circular
                        objectFit: "cover",
                        marginRight: 6,
                      }}
                    />
                  ) : (
                    <Avatar size="small" style={{ backgroundColor: "#87d068", marginRight: 6 }}>
                      {comment.user?.name?.charAt(0).toUpperCase()}
                    </Avatar>
                  )}
         
          <div style={{ flex: 1 }}>
            {/* Name + Time + Menu */}
            <Space style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <Text strong style={{ fontSize: 14, color: "#222" }}>
                {comment.user?.name}
              </Text>

              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {convertDateToUserTimezone(comment.created_at, DateTimeFormat)}
                </Text>

                {isOwner && (
                  <Dropdown
                    menu={{
                      items: [
                        {
                          key: "edit",
                          label: "Edit",
                          onClick: () => {
                            // setEditingCommentId(comment.id);
                            // setEditText(comment.content);
                            openEditorForEdit(comment);
                          },
                        },
                        // {
                        //   key: "delete",
                        //   label: "Delete",
                        //   danger: true,
                        //   onClick: () => handleDeleteComment(comment.id),
                        // },
                      ],
                    }}
                    trigger={["click"]}
                  >
                    <MoreOutlined style={{ cursor: "pointer", fontSize: 16 }} />
                  </Dropdown>
                )}
              </div>
            </Space>

            {/* Comment Content or Edit Box */}
            {!isEditing ? (

              <div style={{ marginTop: 6, marginBottom: 10, fontSize: 14 }}>
                 <HtmlContent content={comment.content} />
              </div>


            ) : (
              <div style={{ marginTop: 6, marginBottom: 10 }}>
                <MessageInput
                  onSend={handleAddComment}           // re-uses existing add/update handler
                  users={users}
                  setNewComment={setNewComment}
                  newComment={newComment}             // openEditorForEdit already sets this
                  attachments={attachments}
                  setAttachments={setAttachments}
                  initialMessage={newComment}
                />
                <Space style={{ marginTop: 8 }}>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => handleAddComment()} // Save (will perform PUT when editingCommentId is set)
                  >
                    Save
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      setEditingCommentId(null);
                      setNewComment("");
                      setAttachments([]);
                    }}
                  >
                    Cancel
                  </Button>
                </Space>
              </div>
            )}

            {/* Attachments */}
            {comment.attachments?.length > 0 && !isEditing && (
              <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 8 }}>
                {comment.attachments.map((att, idx) => (
                  <Tag
                    key={idx}
                    icon={<PaperClipOutlined />}
                    style={{
                      cursor: "pointer",
                      borderRadius: 6,
                      padding: "4px 8px",
                      fontSize: 12,
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#e6f7ff", // soft light blue

                    }}
                    onClick={() => handleFilePreview(att.filename, att?.base_64_data)}
                  >
                    {att.filename}
                  </Tag>
                ))}
              </div>
            )}

            {/* Actions */}

            {!isEditing && (
              <Space size="middle" style={{ marginTop: 10, flexWrap: "nowrap" }}>
                {/* Reactions display */}
                {comment.reactions && comment.reactions.length > 0 && (
                  <div style={{ display: "flex", gap: 12 }}>
                    {comment.reactions.map((reaction) => (
                      <span
                        key={reaction.emoji}
                        style={{
                          cursor: "default",
                          userSelect: "none",
                          display: "inline-flex",
                          alignItems: "center",
                          fontSize: 14,
                          color: "#555",
                        }}
                        title={`Users reacted: ${reaction.users.length}`}
                      >
                        <span style={{ fontSize: 18 }}>{reaction.emoji}</span>
                        <span style={{ marginLeft: 4 }}>{reaction.count}</span>
                      </span>
                    ))}
                  </div>
                )}

                <Dropdown menu={emojiMenu(comment.id)} trigger={["click"]}>
                  <span style={{ cursor: "pointer" }}>
                    <SmileOutlined /> +
                  </span>
                </Dropdown>

                <span
                  style={{ cursor: "pointer", color: "#1890ff" }}
                  onClick={() =>
                    setActiveReplyId((prev) => (prev === comment.id ? null : comment.id))
                  }
                >
                  Reply
                </span>
              </Space>
            )}



            {/* Reply Box */}
            {isReplying && !isEditing && (
              <div style={{ marginTop: 12 }}>
                <div style={{ display: "flex", alignItems: "center", border: "1px solid #080202ff", borderRadius: 6, padding: "6px 8px", }}>

                  <Mentions
                    rows={2}
                    placeholder="Write a reply..."
                    value={replyText[comment.id] || ""}
                    onChange={(val) =>
                      setReplyText((prev) => ({
                        ...prev,
                        [comment.id]: val,
                      }))
                    }
                    onPressEnter={(e) => {
                      if (!e.shiftKey) {
                        e.preventDefault();
                        handleReply(comment.id);
                        setActiveReplyId(null);
                      }
                    }}
                    prefix="@"
                    style={{
                      border: "none",
                      resize: "none",
                      boxShadow: "none",
                      flex: 1,
                    }}
                  >
                    {Array.isArray(users) &&
                      users.map((user) => (
                        <Option key={user.Name} value={user.username}>
                          {user.Name}
                        </Option>
                      ))}
                  </Mentions>

                  {/* Reply Attachment Upload */}
                  <Upload
                    multiple
                    beforeUpload={(file) => {
                      const reader = new FileReader();
                      reader.onload = () => {
                        const base64 = reader.result.split(",")[1];
                        setReplyAttachments(prev => [
                          ...(Array.isArray(prev) ? prev : []),
                          { filename: file.name, base64code: base64 }
                        ]);
                      };
                      reader.readAsDataURL(file);
                      return false; // prevent automatic upload
                    }}
                    showUploadList={false}
                  >
                    <Tooltip title="Attach file">
                      <Button type="text" icon={<PaperClipOutlined />} style={{ marginRight: 8 }} />
                    </Tooltip>
                  </Upload>

                  {/* Send Reply Button */}
                  <Tooltip title="Send Reply">
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<SendOutlined />}
                      onClick={() => {
                        handleReply(comment?.id);
                        setActiveReplyId(null);
                      }}
                    />
                  </Tooltip>
                </div>

                {/* Uploaded Reply Attachments Preview */}
                {replyAttachments?.length > 0 && (
                  <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {replyAttachments.map((att, idx) => (
                      <Tag
                        key={idx}
                        icon={<PaperClipOutlined />}
                        style={{
                          cursor: "pointer",
                          borderRadius: 6,
                          padding: "4px 8px",
                          fontSize: 12,
                          backgroundColor: "#e6f7ff",
                          color: "#0050b3",
                          border: "1px solid #91d5ff",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => handleFilePreview(att.filename, att?.base_64_data)}
                      >
                        {att.filename}
                        <DeleteOutlined
                          style={{ marginLeft: 6, color: "#ff4d4f" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setReplyAttachments((prev) => ({
                              ...prev,
                              [comment.id]: prev[comment.id]?.filter((_, i) => i !== idx),
                            }));
                          }}
                        />
                      </Tag>
                    ))}
                  </div>
                )}
              </div>


            )}

            {/* Replies */}
            {comment.replies?.length > 0 && (
              <div style={{ marginTop: 12, paddingLeft: 40 }}>
                {comment.replies.map((reply) => {
                  const isReplyOwner = reply.user?.id === currentuserId;
                  const isReplyEditing = editingReplyId === reply.id;
 
                  return (
                    <Card
                      key={reply.id}
                      size="small"
                      style={{
                        marginBottom: 8,
                        borderRadius: 6,
                        border: "1px solid #f0f0f0",
                        background: "#fff",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                      }}
                      bodyStyle={{ padding: 8 }}
                    >
                      <Space align="start" style={{ width: "100%" }}>
                         {reply?.user?.image ? (
                    <img
                      src={`data:image/png;base64,${reply?.user?.image}`}
                      alt="profile"
                      style={{
                        width: 24, // Avatar small size
                        height: 24,
                        borderRadius: "50%", // circular
                        objectFit: "cover",
                        marginRight: 6,
                      }}
                    />
                  ) : (
                    <Avatar size="small" style={{ backgroundColor: "#87d068", marginRight: 6 }}>
                      {reply.user?.name?.charAt(0).toUpperCase()}
                    </Avatar>
                  )}

                        <div style={{ flex: 1 }}>
                          {/* Name + Time + Menu */}
                          <Space
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div>
                              <Text strong style={{ fontSize: 12 }}>
                                {reply.user?.name}
                              </Text>{" "}
                              <Text type="secondary" style={{ fontSize: 10 }}>
                                {reply.created_at
                                  ? convertDateToUserTimezone(reply.created_at, DateTimeFormat)
                                  : null}
                              </Text>
                            </div>

                            {isReplyOwner && (
                              <Dropdown
                                menu={{
                                  items: [
                                    {
                                      key: "edit",
                                      label: "Edit",
                                      onClick: () => {
                                        setEditingReplyId(reply.id);
                                        setEditReplyText(reply.content);
                                      },
                                    },
                                    // {
                                    //   key: "delete",
                                    //   label: "Delete",
                                    //   danger: true,
                                    //   onClick: () => handleDeleteReply(comment.id, reply.id),
                                    // },
                                  ],
                                }}
                                trigger={["click"]}
                              >
                                <MoreOutlined style={{ cursor: "pointer", fontSize: 14 }} />
                              </Dropdown>
                            )}
                          </Space>

                          {/* Reply content or edit mode */}
                          {!isReplyEditing ? (
                            <>
                              <div style={{ fontSize: 12, marginTop: 4 }}>{reply.content}</div>

                              {/* Reply attachments display */}
                              {reply.attachments?.length > 0 && (
                                <div
                                  style={{
                                    marginTop: 6,
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 6,
                                  }}
                                >
                                  {reply.attachments.map((att, idx) => (
                                    <Tag
                                      key={idx}
                                      color="geekblue"
                                      style={{ cursor: "pointer", fontSize: 12 }}
                                      onClick={() => handleFilePreview(att.filename, att?.base_64_data)}
                                    >
                                      {att.filename}
                                    </Tag>
                                  ))}
                                </div>
                              )}
                            </>
                          ) : (
                            <div style={{ marginTop: 4 }}>
                              <Mentions
                                rows={2}
                                autoFocus
                                value={editReplyText}
                                onChange={(val) => setEditReplyText(val)}
                                prefix="@"
                                style={{ marginBottom: 6 }}
                              >
                                {Array.isArray(users) &&
                                  users.map((user) => (
                                    <Option key={user.Name} value={user.username}>
                                      {user.Name}
                                    </Option>
                                  ))}
                              </Mentions>
                              <Space>
                                <Button
                                  type="primary"
                                  size="small"
                                  onClick={() => handleEditReply(comment.id, reply.id)}
                                >
                                  Save
                                </Button>
                                <Button size="small" onClick={() => setEditingReplyId(null)}>
                                  Cancel
                                </Button>
                              </Space>
                            </div>
                          )}
                        </div>


                      </Space>
                      {!isReplyEditing && (
                        <Space size="middle" style={{ marginTop: 10, flexWrap: "nowrap" }}>
                          {/* Reactions display */}
                          {reply.reactions && reply.reactions.length > 0 && (
                            <div style={{ display: "flex", gap: 12 }}>
                              {reply.reactions.map((reaction) => (
                                <span
                                  key={reaction.emoji}
                                  style={{
                                    cursor: "default",
                                    userSelect: "none",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    fontSize: 14,
                                    color: "#555",
                                  }}
                                  title={`Users reacted: ${reaction.users.length}`}
                                >
                                  <span style={{ fontSize: 18 }}>{reaction.emoji}</span>
                                  <span style={{ marginLeft: 4 }}>{reaction.count}</span>
                                </span>
                              ))}
                            </div>
                          )}

                          <Dropdown menu={emojiMenu(reply.id)} trigger={["click"]}>
                            <span style={{ cursor: "pointer" }}>
                              <SmileOutlined /> +
                            </span>
                          </Dropdown>


                        </Space>
                      )}
                    </Card>
                  );
                })}
              </div>
            )}


          </div>
        </Space>
      </Card>
    );
  };



  return (

    <Spin spinning={loading} >

      <Card
        title={
          <Title level={4} style={{ margin: 0 }}>
                        {`${objectName} Comments`}
            </Title>
        }  
        style={{
          maxWidth: 900,
          borderRadius: 7,
          boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
          marginTop:0,
          marginBottom:0
        }}
      >
        
        {metadata?.allowComments ? (

          // <div
          //   style={{
          //     display: "flex",
          //     flexDirection: "column",
          //     height: "60vh",
          //   }}
          // >

          //   {/* Fixed Add Comment UI (replaced with MessageInput) */}
          //   <div
          //     style={{
          //       borderRadius: 10,
          //       padding: "6px 8px",
          //       marginBottom: 16,
          //       backgroundColor: theme === "dark" ?"#1A1A1A": "#ffffff" ,
          //       color: theme === "dark" ? "#ffffff" : "#1A1A1A",
          //     }}
          //   >
          //     <MessageInput
          //       onSend={handleAddComment}
          //       users={users}
          //       setNewComment={setNewComment}
          //       newComment={newComment}
          //       attachments={attachments}
          //       setAttachments={setAttachments}
          //       initialMessage={newComment}
          //     />
          //   </div>

          //   {/* Scrollable comments area */}
          //   <Text strong style={{ fontSize: 16, margin: "12px 0", display: "block" }}>
          //     Latest Comments
          //   </Text>
          //   <div
          //     style={{
          //       flex: 1,
          //       overflowY: "auto",
          //       paddingBottom: 12,
          //     }}
          //   >
          //     <List
          //       dataSource={[...(comments || [])]
          //         .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))}
          //       renderItem={(item) => renderComment(item)}
          //       locale={{ emptyText: "No comments yet" }}
          //     />
          //   </div>


          // </div>

          <Editor
            handleSend={handleAddComment}
            users={users}
            comments={comments}
            isOpenChatbox={false}
            handleReact={handleReact}
            handleReply={handleReply}
            handleEditReply={handleEditReply}
            handleEditComment={handleEditComment}
          />
        ) : (
          <Card
            style={{
              maxWidth: 900,
              margin: "24px auto",
              borderRadius: 12,
              textAlign: "center",
              padding: "40px 20px",
            }}
          >
            <Text type="danger" strong>
              You don't have permission to view the feed
            </Text>
          </Card>
        )}
      </Card>

    </Spin>
  );

};


export default Feed;
